module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70017/img/no-theme.png"